import { useEffect, useState } from "react";
import { Modal, Container, Col, Row, Form } from "react-bootstrap";
import DatePicker from "../DatePicker";
import Checkbox from "../../components/Checkbox";
import api from "../../services/api";
import IcX from "../../components/Svg/IcX";
import IcDuplicar from "../../components/Svg/IcDuplicar";
import IcFeito from "../../components/Svg/IcFeito";
import IcNotification from "../../components/Svg/IcNotification";
import { templateActivity, statusSchedule } from "../../util/functions";
import Slct from "../Slct";
import BoxCheckbox from "../BoxCheckbox";
import styleButton from "../Button/Button.module.css";
import Comments from "../Comments";
import WriteComment from "../Comments/WriteComment";
import styles from "./style.module.css";
import Button from "../../components/Button";
import * as yup from "yup";
import { toast } from "react-toastify";
import useWrapper from "../../hooks/useWrapper";
import SwitchCheckbox from "../SwitchCheckBox";
import Required from "../Required";
import useFormat from "../../hooks/utils/useFormat";
import ModalConfirm from "./modal-confirm";

const ModalAddTask = props => {
  const { itemId, show, onHide, turmaId = "", reload, turmaDisabled = false, ...other } = props;

  const { me, config, token } = useWrapper();
  const permissions = JSON.parse(me.permissions);

  const { stringToDate } = useFormat();

  const [schedule, setSchedule] = useState({ id: "", title: "", status: "foreseen", commercial_id: parseInt(turmaId) });
  const [commercial, setCommercial] = useState({});
  const [messages, setMessages] = useState([]);
  const [messageWrite, setMessageWrite] = useState();

  const [modalLoaded, setModalLoaded] = useState(false);
  const [messagesLoaded, setMessagesLoaded] = useState(false);
  const [lastModal, setLastModal] = useState();

  const [formError, setFormError] = useState("");

  const createSchema = yup.object().shape({
    // commercial_id: yup.string().required("Por favor, selecione uma turma"),
    date_end: yup.string().required("Por favor, insira a data de encerramento."),
    date_start: yup.string().required("Por favor, insira a data."),
    title: yup.string().required("Por favor, insira o Nome da Tarefa."),
  });

  let turmaOptions = [{ value: null, label: "Nenhuma", name: "commercial_id" }];

  const saveActivity = (template, turma, task, status) => {
    if (permissions.commercial.reading) {
      api.post(
        "activity",
        {
          message: templateActivity(template, turma, task, status),
          user_id: me.id,
          commercial_id: schedule.commercial_id,
          type: "act",
        },
        config,
      );
    }
  };

  const closeModal = () => {
    setFormError(" ");
    onHide();
    setMessagesLoaded(false);
    setModalLoaded(false);
    setdeleteModal(false);
  };
  const handleInput = e => {
    setSchedule({
      ...schedule,
      [e.target.name]: e.target.value,
    });
  };
  const handleDate = (date, nameInput) => {
    setSchedule({
      ...schedule,
      [nameInput]: date,
    });
  };
  const handleCheckbox = e => {
    setSchedule({
      ...schedule,
      [e.target.name]: e.target.checked,
    });
  };
  const handleMessage = e => {
    setMessageWrite(e.target.value);
  };
  const handleSubmit = () => {
    createSchema
      .validate({
        title: schedule.title,
        date_start: schedule.date_start,
        date_end: schedule.all_day ? true : schedule.date_end,
      })
      .then(() => {
        if (itemId) {
          //Edit
          setloadingRequest(true);
          api
            .put(
              `calendars/${itemId}`,
              {
                title: schedule.title,
                description: schedule.description,
                commercial_id: schedule.commercial_id,
                date_start: schedule.date_start,
                date_end: schedule.date_end,
                status: schedule.status,
                all_day: schedule.all_day,
                for_trainees: schedule.for_trainees,
                event_id: schedule.event_id,
                category_id: schedule.category_id,
                resource_id: schedule.resource_id,
                user_id: me.id,
              },
              config,
            )
            .then(() => {
              !!schedule?.commercial_id &&
                saveActivity(2, schedule.commercial_id, schedule.title, statusSchedule(schedule.status));
            })
            .then(() => {
              setloadingRequest(false);
              toast.success("Tarefa modificada com sucesso!");
              reload();
              setSchedule({ id: "", title: "", status: "foreseen", commercial_id: parseInt(turmaId) });
            });
        } else {
          //Create
          setloadingRequest(true);
          api
            .post(
              "calendars",
              {
                title: schedule.title,
                description: schedule.description,
                commercial_id: schedule.commercial_id,
                date_start: schedule.date_start,
                date_end: schedule.date_end,
                status: schedule.status,
                all_day: schedule.all_day,
                for_trainees: schedule.for_trainees,
                event_id: schedule.event_id,
                category_id: schedule.category_id,
                resource_id: schedule.resource_id,
                user_id: me.id,
              },
              config,
            )
            .then(() => {
              !!schedule?.commercial_id &&
                saveActivity(2, schedule.commercial_id, schedule.title, statusSchedule(schedule.status));
            })
            .then(() => {
              setloadingRequest(false);
              toast.success("Tarefa criada com sucesso!");
              reload();
              setSchedule({ id: "", title: "", status: "foreseen", commercial_id: parseInt(turmaId) });
            });
        }
        closeModal();
      })
      .catch(function (err) {
        let inputError = document.querySelector(`[name='${err.path}']`);
        let inputErrorParent = inputError.parentElement.parentElement;
        inputErrorParent.setAttribute("data-validation", "error");
        inputError.addEventListener("focus", () => {
          inputErrorParent.setAttribute("data-validation", "");
        });
        setFormError(err.message);
        toast.error(err.message);
      });
  };

  const handleDelete = async () => {
    closeModal();
    try {
      await api.put(`calendars/${itemId}`, { active: 0 }, config);
      toast.success("Tarefa excluída com sucesso!");
      !!schedule?.commercial_id &&
        saveActivity(3, schedule.commercial_id, schedule.title, statusSchedule(schedule.status));
      reload();
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Erro ao tentar excluir a tarefa.");
    }
  };
  const duplicateContent = () => {
    api
      .post(
        "calendars",
        {
          title: "Copia de " + schedule.title,
          description: schedule.description,
          date_start: schedule.date_start,
          date_end: schedule.date_end,
          commercial_id: schedule.commercial_id,
          status: schedule.status,
          all_day: schedule.all_day,
          event_id: schedule.event_id,
          category_id: schedule.category_id,
          resource_id: schedule.resource_id,
          user_id: me.id,
        },
        config,
      )
      .then(() => {
        closeModal();
      })
      .then(() => {
        !!schedule?.commercial_id &&
          saveActivity(6, schedule.commercial_id, schedule.title, statusSchedule(schedule.status));
      })
      .then(() => {
        toast.success("Tarefa duplicada com sucesso!");
        reload();
      });
  };
  const toggleNotification = () => {
    api.put(`calendars/${schedule.id}`, { notification: !schedule.notification }, config).then(() => {
      toast.success(schedule.notification ? "Notificações desativadas!" : "Notificações ativadas!");
    });
    setSchedule({
      ...schedule,
      notification: !schedule.notification,
    });
  };
  const toggleDone = () => {
    api
      .put(`calendars/${schedule.id}`, { done: !schedule.done }, config)
      .then(() => {
        setSchedule({
          ...schedule,
          done: !schedule.done,
        });
        closeModal();
      })
      .then(() => {
        !!schedule?.commercial_id &&
          saveActivity(8, schedule.commercial_id, schedule.title, statusSchedule(schedule.status));
      })
      .then(() => {
        toast.success("Status alterado com sucesso!");
        reload();
      });
  };

  // Comments Related
  const loadMessages = id => {
    api
      .get("messages", {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          calendar_id: id,
        },
      })
      .then(response => {
        return response.data.data;
      })
      .then(response => {
        setMessages(response);
        setMessagesLoaded(true);
      })
      .catch(err => {
        console.error(err);
      });
  };
  const saveMessage = () => {
    api
      .post(
        "messages",
        {
          message: messageWrite,
          user_id: me.id,
          calendar_id: schedule.id,
        },
        config,
      )
      .then(() => {
        setMessageWrite("");
        loadMessages(schedule.id);
      });
  };
  const [attendanceCategoryRaw, setattendanceCategoryRaw] = useState([]);

  useEffect(() => {
    if (permissions.commercial.reading) {
      api.get("commercial?is_class=1&joins=institution,course", config).then(response => {
        setCommercial(response.data);
      });
    }
    api.get(`categories`, config).then(response => {
      setattendanceCategoryRaw(response.data.data);
    });
  }, []);

  const [events2, setevents2] = useState();
  const [resources2, setresources2] = useState();
  useEffect(() => {
    if (attendanceCategoryRaw) {
      setevents2(
        attendanceCategoryRaw.map(e => ({
          label: e.name,
          options: e.event.map(e2 => ({
            label: e2.name,
            value: e2.id,
            category_id: e2.category_id,
          })),
        })),
      );
      let _all_resources = [];
      attendanceCategoryRaw.forEach(e => {
        e.resource.forEach(e2 => {
          _all_resources.push({
            value: e2.id,
            label: e2.name,
            category_id: e.id,
          });
        });
      });
      setresources2(_all_resources);
    }
  }, [attendanceCategoryRaw]);

  useEffect(() => {
    if (itemId) {
      api
        .get(`calendars/${itemId}`, config)
        .then(response => {
          const _date_start = stringToDate(response.data.date_start);
          const _date_end = stringToDate(response.data.date_end);
          response.data.date_start = !!_date_start?.getDate() ? _date_start : null;
          response.data.date_end = !!_date_end?.getDate() ? _date_end : null;
          setSchedule(response.data);
        })
        .then(() => {
          loadMessages(itemId);
        })
        .catch(err => {
          console.error(err);
        });
    } else {
      setSchedule({ id: "", title: "", status: "foreseen", commercial_id: parseInt(turmaId) });
      setMessagesLoaded(true);
    }
  }, [show]);

  useEffect(() => {
    if (show) {
      if (itemId === lastModal) {
        setModalLoaded(true);
        setMessagesLoaded(true);
      }
    }
    setFormError("");
  }, [show]);

  useEffect(() => {
    if (show) {
      setModalLoaded(true);
      setLastModal(schedule.id);
    }
  }, [schedule]);
  const [loadingRequest, setloadingRequest] = useState(false);

  const [deleteModal, setdeleteModal] = useState(false);

  return (
    <>
      <Modal size="lg" show={modalLoaded && messagesLoaded && show} onHide={closeModal}>
        {/* <Form> */}
        <Form>
          <Modal.Header>
            <div as="label" className="d-flex w-100">
              <Form.Control
                type="text"
                onChange={handleInput}
                name="title"
                value={schedule.title}
                placeholder="Insira o nome da Tarefa..."
                className={styles.HeaderInput}
              />
            </div>
            <button type="button" className={styles.closeModal} onClick={closeModal}>
              <IcX />
            </button>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <div>
                {/* <Row>
                    <Col>
                      {itemId && (
                        <p style={{fontSize: ".8em", opacity: .5, marginTop: "-.75rem", marginBottom: ".5rem", fontStyle: "italic"}}>(Cód {new Date().getFullYear() + '' + schedule.id})</p>
                      )}
                    </Col>
                  </Row> */}
                <Row>
                  <Col sm={8}>
                    <Row>
                      <Col>
                        <Form.Group as="label" className="d-block">
                          <span className="d-block">Descrição</span>
                          <textarea
                            name="description"
                            onChange={handleInput}
                            value={schedule.description}
                            className="form-control"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col>
                        <Form.Group className="d-block">
                          <span className="d-block">
                            Data <Required />
                          </span>
                          <DatePicker
                            selected={schedule?.date_start}
                            changeDate={__date => {
                              let _date_base = new Date(__date);

                              if (!!schedule?.date_end) {
                                const _date_end = new Date(schedule?.date_end);
                                _date_base.setHours(_date_end.getHours(), _date_end.getMinutes());
                              }

                              setSchedule({
                                ...schedule,
                                date_start: new Date(__date),
                                date_end: new Date(_date_base),
                              });
                            }}
                          />
                        </Form.Group>
                      </Col>
                      {!schedule.all_day && (
                        <>
                          <Col>
                            <Form.Group className="d-block">
                              <span className="d-block">
                                Início <Required />
                              </span>
                              <DatePicker
                                name="date_start"
                                selected={schedule.date_start}
                                changeDate={__date => {
                                  let _date_base = new Date(__date);

                                  if (!!schedule?.date_end) {
                                    const _date_end = new Date(schedule?.date_end);
                                    _date_base.setHours(_date_end.getHours(), _date_end.getMinutes());
                                  }

                                  setSchedule({
                                    ...schedule,
                                    date_start: new Date(__date),
                                    date_end: new Date(_date_base),
                                  });
                                }}
                                showTimeSelect
                                showTimeSelectOnly
                                timeFormat="HH:mm"
                                timeIntervals={15}
                                dateFormat="HH:mm"
                                placeholder="--:--"
                              />
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group className="d-block">
                              <span className="d-block">
                                Fim <Required />
                              </span>
                              <DatePicker
                                name="date_end"
                                selected={schedule.date_end}
                                changeDate={__date => {
                                  let _date_base = new Date(schedule.date_start || new Date());
                                  let _date_end = new Date(__date);

                                  _date_base.setHours(_date_end.getHours(), _date_end.getMinutes());
                                  setSchedule({
                                    ...schedule,
                                    date_end: new Date(_date_base),
                                  });
                                }}
                                showTimeSelect
                                showTimeSelectOnly
                                timeFormat="HH:mm"
                                timeIntervals={15}
                                dateFormat="HH:mm"
                                placeholder="--:--"
                              />
                            </Form.Group>
                          </Col>
                        </>
                      )}
                      <Col sm={12}>
                        <SwitchCheckbox
                          label="Dia Inteiro"
                          checked={schedule.all_day}
                          onChange={__ev => {
                            setSchedule({
                              ...schedule,
                              all_day: __ev.target.checked,
                            });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col sm={6}>
                        <Form.Group className="d-block">
                          <span className="d-block">Evento</span>
                          <Slct
                            options={[
                              {
                                label: " ",
                                options: [
                                  {
                                    label: "Nenhum",
                                    value: null,
                                    category_id: "",
                                  },
                                ],
                              },
                            ].concat(events2 || [])}
                            value={schedule.event_id}
                            onChange={ev => {
                              setSchedule({
                                ...schedule,
                                event_id: ev.value,
                                category_id: ev.category_id,
                              });
                            }}
                            formatGroupLabel={true}
                            className="w-100"
                            placeholder="..."
                          />
                        </Form.Group>
                      </Col>
                      <Col sm={6}>
                        <Form.Group className="d-block">
                          <span className="d-block">Recurso</span>
                          <Slct
                            options={[
                              {
                                label: "Nenhum",
                                value: null,
                              },
                            ].concat(resources2?.filter(e2 => e2.category_id === schedule?.category_id) || [])}
                            value={schedule?.resource_id}
                            onChange={ev => {
                              setSchedule({
                                ...schedule,
                                resource_id: ev.value,
                              });
                            }}
                            className="w-100"
                            placeholder="..."
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    {permissions.commercial.reading && (
                      <Row className="mt-2">
                        <Col>
                          <Form.Group className="d-block">
                            {commercial !== undefined &&
                              commercial.length > 0 &&
                              commercial.forEach(cmml => {
                                let courseTitle = cmml?.course?.title || "-";
                                let courseYear = `${cmml.year || "-"}.${cmml.period || "-"}`;
                                let courseInstitution = cmml?.institution?.title || "-";
                                let label = `${courseTitle} ${courseYear} ${courseInstitution}`;

                                turmaOptions.push({
                                  value: cmml.id,
                                  label: label,
                                  name: "commercial_id",
                                  is_class: cmml.is_class,
                                });
                              })}
                            <span className="d-block">Turma</span>
                            <Slct
                              options={turmaOptions}
                              className="w-100"
                              value={schedule.commercial_id}
                              name="commercial_id"
                              placeholder="..."
                              isDisabled={turmaDisabled}
                              onChange={e => {
                                setSchedule({
                                  ...schedule,
                                  commercial_id: parseInt(e.value),
                                  is_class: e.is_class,
                                });
                              }}
                            />
                          </Form.Group>
                        </Col>
                        {!!schedule.commercial_id && (
                          <Col sm={12} className="mt-3">
                            <Form.Group as="label" className="d-flex" style={{ marginTop: "-.5rem" }}>
                              <Checkbox name="for_trainees" checked={schedule.for_trainees} onChange={handleCheckbox} />
                              <span className="ml-2">Exibir tarefa para os formandos da turma?</span>
                            </Form.Group>
                          </Col>
                        )}
                      </Row>
                    )}
                    <Row className="mt-4">
                      <Col sm={12}>
                        {itemId && (
                          <>
                            <h2 className="page-title mb-3">Comentários</h2>
                            <div className="listSpace">
                              <Comments messages={messages} />
                              <WriteComment
                                value={messageWrite}
                                onChange={handleMessage}
                                name="messageWrite"
                                placeholder="Adicione o seu comentário"
                                buttonClick={saveMessage}
                              />
                            </div>
                          </>
                        )}
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <Row>
                      <Col>
                        {itemId && (
                          <div className="mb-3">
                            <button
                              className={`justify-content-start w-100 ${styleButton.button_clean}`}
                              type="button"
                              onClick={toggleDone}
                            >
                              <IcFeito />
                              <span>{schedule.done ? "Desmarcar" : "Marcar"} como feito</span>
                            </button>
                            <button
                              className={`justify-content-start text-left w-100 mt-2 ${styleButton.button_clean}`}
                              type="button"
                              onClick={duplicateContent}
                            >
                              <IcDuplicar />
                              <span>Duplicar</span>
                            </button>
                            <button
                              className={`justify-content-start text-left w-100 mt-2 ${styleButton.button_clean}`}
                              type="button"
                              onClick={toggleNotification}
                            >
                              <IcNotification />
                              <span>{schedule.notification ? "Desativar" : "Ativar"} Notificações</span>
                            </button>
                          </div>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        {schedule.done !== 1 && schedule.status !== "pending" && (
                          <>
                            <span className="d-block">Status</span>
                            <div className="d-flex flex-column">
                              <BoxCheckbox
                                label="Previsto"
                                name="status"
                                value="foreseen"
                                onChange={handleInput}
                                className={schedule.status === "foreseen" && "active"}
                                status={schedule.status === "foreseen"}
                                colorScheme="ok"
                              />
                              <BoxCheckbox
                                label="Confirmado"
                                name="status"
                                value="confirmed"
                                onChange={handleInput}
                                className={schedule.status === "confirmed" && "active"}
                                status={schedule.status === "confirmed"}
                                colorScheme="success"
                              />
                            </div>
                          </>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <p className={styles.formError}>{formError}</p>
            <div className="w-100 d-flex justify-content-between">
              <div>
                {!!schedule?.id && (
                  <Button type="submit" loading={loadingRequest} onClick={() => setdeleteModal(true)} color="error">
                    Excluir
                  </Button>
                )}
              </div>
              <div>
                <Button type="submit" loading={loadingRequest} onClick={handleSubmit}>
                  {!!schedule?.id ? "Salvar" : "Criar Tarefa"}
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
      <ModalConfirm
        show={deleteModal}
        title={"Excluir Tarefa"}
        text={`Deseja excluir a tarefa?`}
        closeModal={() => setdeleteModal(false)}
        confirm={handleDelete}
        colorScheme="error"
        className="mt-5"
      />
    </>
  );
};

export default ModalAddTask;
